import type {ExtractPropsWithoutRef} from '@/types';

import {Button} from '@travel-frontend/ui-components';
import {useTranslation} from 'react-i18next';

import {useAppSelector} from '@/redux/config';
import {getHotelCountFiltered} from '@/redux/v1/hotels/list/reducer';
import {testId} from '@/utils/testId';

export const CallToActionButton = ({
  loading,
  onClick,
}: ExtractPropsWithoutRef<typeof Button>) => {
  const {t} = useTranslation('hotels');
  const hotelCountFiltered = useAppSelector(getHotelCountFiltered);

  return (
    <Button
      loading={loading}
      onClick={onClick}
      fullWidth
      data-testid={testId('filter-layer-accept')}
    >
      {t('buttons.displayHotels', {
        count: hotelCountFiltered,
      })}
    </Button>
  );
};
